"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEDDPreview = void 0;
const client_1 = require("@apollo/client");
const use_edd_preview_graphql_1 = require("./use-edd-preview.graphql");
const AccountContext_1 = require("contexts/AccountContext");
const useEDDPreview = () => {
    var _a;
    const { account } = (0, AccountContext_1.useAccount)();
    const getEDDConfig = (0, client_1.useQuery)(use_edd_preview_graphql_1.GET_EDD_PREVIEW, {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        variables: { accountId: account.id },
        fetchPolicy: 'network-only',
        skip: !(account === null || account === void 0 ? void 0 : account.id)
    });
    const { error, loading, data, refetch } = getEDDConfig;
    const eddHTML = ((_a = data === null || data === void 0 ? void 0 : data.estimatedDeliveryDate) === null || _a === void 0 ? void 0 : _a.html) || '';
    return {
        error,
        loading,
        previewHTML: eddHTML,
        refetch
    };
};
exports.useEDDPreview = useEDDPreview;
